module.exports = __webpack_public_path__ + "img/2.bb822bc9.png";